import { useState, useEffect } from "react"
import { Button, Grid, TextField } from "@material-ui/core"
import HeaderModal from "../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import { useFormik } from "formik"
import * as yup from "yup";
import { ToastMessage } from "../../../global/ToastMessage"
import { useDispatch, useSelector } from "react-redux"
import { closeMoadalAltaCiurcuito, crearCirucuitoAction, obtenerCicuitosProvedor, obtenerTerrestreAllAction } from "./../../../ducks/proveedorTerrestreDuck"
import { makeStyles } from "@material-ui/core"
import { offLoadAction, onLoadAnction } from "./../../../ducks/loadDuck"
import { esFechaValida } from "../../../utils/FormatFecha"
import TCircuitosProveedor from "./TCircuitosProveedor"
import PickerModHora from "../../../global/PickersModHora"
export const FormularioReservaStyle = makeStyles((theme) => ({
    textField: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    dateField: {
        width: "98%",
        margin: "5px",
        paddingBottom: 0,
        paddingLeft: 0,
        fontWeight: 500,
    },
    textFieldMultiLinea: {
        width: "97%",
        margin: "5px",
        paddingBottom: 0,
        fontWeight: 500,
    },
    formControl: {
        width: "97%",
        margin: "5px",
    },
    containerSpacing: {
        margin: "10px 0",
    },
    modalBotones: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    modalBotonesCenter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    modalBoton: {
        margin: "1px 0",
        width: "20%",
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "900px",
        margin: "0 auto",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "none",
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        maxWidth: "900px",
        minWidth: "500px",
    },
}))

const validationSchema = yup.object({
    disponibilidad: yup
        .number("Ingresa un numero")
        .positive("numero postivo")
        .required("Es requerido"),
    claveCircuito: yup
        .string("")
        .required("Se requiere clave"),
    dias: yup
        .number("Ingresa un número de días")
        .positive("Número positivo")
        .required("Es requerido"),
    noches: yup
        .number("Ingresa un número de noches")
        .positive("Número positivo")
        .required("Es requerido"),
    suplemento: yup
        .number("Ingresa un suplemento")
        .positive("Número positivo")
        .required("Es requerido"),
})

const initialValues = {
    disponibilidad: 0,
    claveCircuito: "",
    dias: 1,
    noches: 0,
    suplemento: 0,
}

const useProvedorTerrestreCircuitos = ({ id }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerCicuitosProvedor({ id })).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch, id])
}

const FCircuitos = () => {
    const [fechaInicio, setFechaIncio] = useState(new Date())
    const [fechaFin, setFechaFin] = useState(new Date())
    const { provedorCircuito, openCirutoAlta } = useSelector(store => store.proveedorTerrestre)
    useProvedorTerrestreCircuitos({ id: provedorCircuito?.idProveedor })
    const dispatch = useDispatch()
    const classes = FormularioReservaStyle()
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onSave(values)
        },
    })
    const claerForm = () => {
        formik.resetForm(initialValues)
        setFechaIncio(new Date())
        setFechaFin(new Date())
    }
    const handleClose = () => {
        dispatch(closeMoadalAltaCiurcuito())
        claerForm()
    }
    const onSave = (values) => {
        dispatch(onLoadAnction({ message: '' }))
        dispatch(crearCirucuitoAction({
            // ClaveCircuito: `${provedorCircuito?.claveProveedor}FI${FormatoFecha({ date: fechaInicio, formato: "yyyy-MM-dd-HH:MM" })}FF${FormatoFecha({ date: fechaFin, formato: "yyyy-MM-dd-HH:MM" })}`,
            ClaveCircuito: values.claveCircuito,
            Disponibilidad: values.disponibilidad,
            FechaFin: fechaFin,
            FechaInicio: fechaInicio,
            id: provedorCircuito?.idProveedor,
            Dias: Number(values.dias),
            Noches: Number(values.noches),
            Suplemento: Number(values.suplemento),
        })).then(Response => {
            dispatch(offLoadAction())
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null;
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null;
            }
            dispatch(obtenerCicuitosProvedor({ id: provedorCircuito?.idProveedor }))
            dispatch(obtenerTerrestreAllAction())
            claerForm()
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });

        })
    }
    const handleClickSelecFechaInicio = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        setFechaIncio(date)
    }
    const handleClickSelecFechaFinal = (date) => {
        if (!esFechaValida({ date })) {
            return null
        }
        setFechaFin(date)
    }

    const handleDiasChange = (e) => {
        const newDias = e.target.value;
        formik.setFieldValue("dias", newDias);
        formik.setFieldValue("noches", newDias - 1 <= 0 ? 0 : newDias - 1);
    };
    
    const handleNochesChange = (e) => {
        const newNoches = e.target.value;
        formik.setFieldValue("dias", Number(newNoches) + 1);
        formik.setFieldValue("noches", newNoches);
    };

    return (
        <div>
            <ModalBase classes={classes} open={openCirutoAlta} onClose={handleClose}>
                <HeaderModal
                    handleClose={handleClose}
                    titulo={`Nuevo bloque de fechas`}
                />

                <form onSubmit={formik.handleSubmit}>
                    <Grid container className={classes.containerSpacing}>
                    <Grid item xs={6}>
                            <TextField
                                required
                                id="input-clave-ciurcuito"
                                label="Clave"
                                type="text"
                                variant="outlined"
                                name="claveCircuito"
                                value={formik.values.claveCircuito}
                                onChange={formik.handleChange}
                                error={formik.touched.claveCircuito && Boolean(formik.errors.claveCircuito)}
                                helperText={formik.touched.claveCircuito && formik.errors.claveCircuito}
                                className={classes.textField}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                required
                                id="input-Diponibilidad-ciurcuito"
                                label="Disponibilidad"
                                type="text"
                                variant="outlined"
                                name="disponibilidad"
                                value={formik.values.disponibilidad}
                                onChange={formik.handleChange}
                                error={formik.touched.disponibilidad && Boolean(formik.errors.disponibilidad)}
                                helperText={formik.touched.disponibilidad && formik.errors.disponibilidad}
                                className={classes.textField}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <PickerModHora
                                id="fechaIncioCircuito"
                                label="Inicio"
                                selectedDate={fechaInicio}
                                setSelectedDate={handleClickSelecFechaInicio}
                                disablePast={true}
                                disableFuture={false}
                                className={classes.dateField}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <PickerModHora
                                id="fechaFinalCircuito"
                                label="Fin"
                                selectedDate={fechaFin}
                                setSelectedDate={handleClickSelecFechaFinal}
                                disablePast={true}
                                disableFuture={false}
                                className={classes.dateField}
                            />
                        </Grid>
                        
                        <Grid item xs={4}>
                            <TextField
                                required
                                id="input-Dias"
                                label="Dias"
                                type="text"
                                variant="outlined"
                                name="dias"
                                value={formik.values.dias}
                                onChange={handleDiasChange}
                                error={formik.touched.dias && Boolean(formik.errors.dias)}
                                helperText={formik.touched.dias && formik.errors.dias}
                                className={classes.textField}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                required
                                id="input-Noches"
                                label="Noches"
                                type="text"
                                variant="outlined"
                                name="noches"
                                value={formik.values.noches}
                                onChange={handleNochesChange}
                                error={formik.touched.noches && Boolean(formik.errors.noches)}
                                helperText={formik.touched.noches && formik.errors.noches}
                                className={classes.textField}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                required
                                id="input-Suplemento"
                                label="Suplemento"
                                type="text"
                                variant="outlined"
                                name="suplemento"
                                value={formik.values.suplemento}
                                onChange={formik.handleChange}
                                error={formik.touched.suplemento && Boolean(formik.errors.suplemento)}
                                helperText={formik.touched.suplemento && formik.errors.suplemento}
                                className={classes.textField}
                            />
                        </Grid>
                    </Grid>
                    
                    <Grid container className={classes.containerSpacing}>
                        <Grid item xs={12} className={classes.modalBotonesCenter}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className={classes.modalBoton}
                            >
                                Guardar
                            </Button>
                        </Grid>
                    </Grid>
                </form>
                <Grid container className={classes.containerSpacing}>
                    <TCircuitosProveedor />
                </Grid>
            </ModalBase>
        </div>
    )
}
export default FCircuitos